module.exports = __webpack_public_path__ + "img/menu.05dfb965.svg";